// Vendor general settings.
// No settings API exists yet, so values are kept per vendor in this browser.
// When the backend adds one, replace loadGeneralSettings/saveGeneralSettings with
// http calls; the page only depends on these two functions.

export const WEEK_DAYS = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"] as const;

export interface GeneralSettings {
  acceptingOrders: boolean;
  openingTime: string; // HH:mm
  closingTime: string; // HH:mm
  workingDays: string[];
  homeService: boolean; // pharmacy: home delivery, lab: home sample collection
  emailNotifications: boolean;
  smsNotifications: boolean;
}

export const DEFAULT_GENERAL_SETTINGS: GeneralSettings = {
  acceptingOrders: true,
  openingTime: "09:00",
  closingTime: "21:00",
  workingDays: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  homeService: true,
  emailNotifications: true,
  smsNotifications: false,
};

const storageKey = (vendorId: string) => `generalSettings:${vendorId}`;

export const loadGeneralSettings = async (vendorId: string): Promise<GeneralSettings> => {
  try {
    const raw = localStorage.getItem(storageKey(vendorId));
    return raw ? { ...DEFAULT_GENERAL_SETTINGS, ...JSON.parse(raw) } : { ...DEFAULT_GENERAL_SETTINGS };
  } catch {
    return { ...DEFAULT_GENERAL_SETTINGS };
  }
};

export const saveGeneralSettings = async (vendorId: string, settings: GeneralSettings): Promise<void> => {
  localStorage.setItem(storageKey(vendorId), JSON.stringify(settings));
};
